import { network } from 'services/network';

export const updatePoapView = (params) => {
    return network.post('api/bo/updatePoapView', params).then((response) => response.data);
};
